import React, {Fragment} from 'react';

import MediaQuery, {useMediaQuery} from 'react-responsive';

export const BootstrapMinMediumMediaQuery = (
  props: React.ComponentProps<typeof MediaQuery>
) => <MediaQuery {...props} minWidth={768} />;

export const BootstrapMinLargeMediaQuery = (
  props: React.ComponentProps<typeof MediaQuery>
) => <MediaQuery {...props} minWidth={992} />;

export const BootstrapMaxSmallMediaQuery = (props: any) => (
  <MediaQuery {...props} maxWidth={767} />
);

const breakpoints = {
  //xs to sm
  sm: 576,
  //sm to md
  md: 768,
  // md to lg
  lg: 992,
  // lg to xl
  xl: 1200,
} as const;

interface Props {
  breakpoint: keyof typeof breakpoints;
  small?: React.ReactNode;
  large?: React.ReactNode;
}

export function Responsive({breakpoint, small = null, large = null}: Props) {
  return (
    <Fragment>
      {small != null ? (
        <MediaQuery maxWidth={breakpoints[breakpoint] - 1}>{small}</MediaQuery>
      ) : null}
      {large != null ? (
        <MediaQuery minWidth={breakpoints[breakpoint]}>{large}</MediaQuery>
      ) : null}
    </Fragment>
  );
}

export function useIsScreenLargerThan(
  breakpoint: keyof typeof breakpoints
): boolean {
  return !useMediaQuery({
    query: `(max-width: ${breakpoints[breakpoint] - 1}px)`,
  });
}
